import { render, staticRenderFns } from "./compare.vue?vue&type=template&id=51403d93&scoped=true"
import script from "./compare.vue?vue&type=script&lang=js"
export * from "./compare.vue?vue&type=script&lang=js"
import style0 from "./compare.vue?vue&type=style&index=0&id=51403d93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51403d93",
  null
  
)

export default component.exports